module.exports = __webpack_public_path__ + "static/media/oh_pack2_sample008_0001.ab7ff4fd.png";